// extracted by mini-css-extract-plugin
export default {"contactInfo":"UserLink_contactInfo__VHtK8","avatar":"UserLink_avatar__qkk7M","nameLink":"UserLink_nameLink__1aiGy"};